/**
 * Market Breakdown Hook
 *
 * Fetches all current stock and aggregates by marketType.
 * @see Sprint 28 - US-28.3
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import { dashboardKeys } from './useDashboardData';

export interface MarketBreakdownData {
  FOOD: number;
  NON_FOOD: number;
  MAINTENANCE: number;
  total: number;
}

export function useMarketBreakdown() {
  return useQuery({
    queryKey: [...dashboardKeys.all, 'marketBreakdown'] as const,
    queryFn: async (): Promise<MarketBreakdownData> => {
      const result = await dashboardService.getMarketBreakdownData();
      const totals: MarketBreakdownData = { FOOD: 0, NON_FOOD: 0, MAINTENANCE: 0, total: 0 };

      for (const item of result.data) {
        const mt = item.rawProduct.marketType;
        const value = item.stockValue ?? 0;
        if (mt === 'FOOD' || mt === 'FOOD_IND') totals.FOOD += value;
        else if (mt === 'NON_FOOD' || mt === 'NON_FOOD_IND') totals.NON_FOOD += value;
        else if (mt === 'MAINTENANCE') totals.MAINTENANCE += value;
        totals.total += value;
      }

      return totals;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: (prev) => prev,
  });
}
